module.exports = __webpack_public_path__ + "front/img/logo.adeaba7d.png";